import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AddressDTO, OfficeDTO } from '@iota/iota-management-portal-v4-client';
import { IotaModalOptions, IotaModalSize, MAT_DIALOG_DATA, MatDialogRef } from '@iota/iota-ui-components';
import { Store } from '@ngrx/store';
import { UpdateOffice } from 'src/app/store/actions/office.actions';
import { officeActionLoading, officeById } from 'src/app/store/reducer/office.reducer';
import { deepCopy } from '../../constants-and-enums/default-objects';
import { getValueFromStore, waitForBooleanValue } from '../../utils';

export interface OfficeDetailsDialogData {
    officeId?: string;
}

@Component({
    standalone: false,
    selector: 'app-office-details-dialog',
    templateUrl: './office-details-dialog.component.html',
    styleUrls: ['./office-details-dialog.component.scss']
})
export class OfficeDetailsDialogComponent implements OnInit, OnDestroy {
    public modalOptions: Partial<IotaModalOptions> = {
        size: IotaModalSize.SIZE_7XL,
        showToggleFullScreenButton: true
    };

    editMode = false;
    updatedOffice: OfficeDTO = {};
    isAnimating = false;

    constructor(
        public dialogRef: MatDialogRef<OfficeDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: OfficeDetailsDialogData,
        private store: Store
    ) {}

    ngOnInit(): void {
        setTimeout(() => {
            this.isAnimating = true;
        }, 100);
        this.resetValues();
    }

    async resetValues() {
        this.editMode = false;

        const office = await getValueFromStore(this.store, officeById(this.data?.officeId));
        this.updatedOffice = deepCopy(office);
    }

    edit() {
        this.editMode = true;
    }

    save() {
        this.editMode = false;
        this.store.dispatch(
            UpdateOffice({
                id: this.updatedOffice.officeId,
                request: {
                    name: this.updatedOffice.name,
                    address: null,
                    deactivated: this.updatedOffice.deactivated
                }
            })
        );
        this.reloadAfterAction();
    }

    updateAddress(address: AddressDTO) {
        this.store.dispatch(
            UpdateOffice({
                id: this.updatedOffice?.officeId,
                request: {
                    name: null,
                    address: {
                        id: address.addressId,
                        countryCode: address.countryCode,
                        country: address.country,
                        city: address.city,
                        postOfficeBox: address.postOfficeBox,
                        street: address.street,
                        street2: address.street2,
                        houseNumber: address.houseNumber,
                        zipCode: address.zipCode,
                        type: address.addressType,
                        name1: address.name1,
                        name2: address.name2
                    }
                }
            })
        );
        this.reloadAfterAction();
    }

    async reloadAfterAction() {
        await waitForBooleanValue(this.store, officeActionLoading, false);
        this.resetValues();
    }

    ngOnDestroy(): void {
        this.isAnimating = false;
    }
}
